const DATE_TIME_COMBINE = false; 

const GROUPS = {
  string: [
    'string','char','varchar','varchar2','nchar','nvarchar','nvarchar2',
    'text','long','clob','nclob','textarea','phone','picklist','multipicklist',
    'encryptedstring','email','url','location','anytype','id','reference',
    'xml','xmltype','uniqueidentifier','uuid'
  ],
  number: [
    'number','int','integer','smallint','bigint','decimal','numeric',
    'currency','percent','binary_integer'
  ],
  float: ['float','double','real','binary_float','binary_double'],
  boolean: ['boolean','bit'],
  date: ['date'],
  datetime: ['datetime','timestamp', ...(DATE_TIME_COMBINE ? ['date'] : [])],
  blob: ['blob','base64','raw','longraw','varbinary','binary','bytea','image','bfile'],
  interval_year_to_month: ['interval_year_to_month','interval_year_month','string'],
  interval_day_to_second: ['interval_day_to_second','interval_day_second','string'],
  
};

const expandSymmetric = (groups) => {
  const map = {};
  for (const members of Object.values(groups)) {
    const full = Array.from(new Set(members));
    for (const m of full) map[m] = full;
  }
  return map;
};

export const typeAliasMap = expandSymmetric(GROUPS);
